module.exports = __webpack_public_path__ + "img/del.58c86204.svg";